// extracted by mini-css-extract-plugin
export var text = "_5b-0";